import { timeFormat, timeParse } from 'd3-time-format';
// import { line, curveMonotoneX } from 'd3-shape';
import { line } from 'd3-shape';
// import { extent, max, min } from 'd3-array';
import { extent } from 'd3-array';
import { linearAxis, timeAxis } from '../../../factory/axes';
import { ordinalScale } from '../../../factory/scales';

import raw from './data/data.json';
// import { business } from './utils/colors';

export default function (props) {
  const {
    initialWidth, initialHeight, isMobile, calloutValue, calloutLabel, recessionEnd,
  } = props;

  const margins = {
    top: 20,
    right: isMobile ? 50 : 50,
    bottom: 35,
    left: 35,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  const parser = timeParse('%Y-%m-%d'); // https://github.com/d3/d3-time-format;
  console.log(raw);
  const keys = Object.keys(raw[0]).slice(1);

  const data = keys.map(id => ({ id, values: raw.map(d => ({ date: parser(d.date), value: +d[id] })) }));

  console.log(data);

  const rParser = timeParse('%m/%d/%Y'); // https://github.com/d3/d3-time-format;
  const recessionData = [
    // { start: '8/1/1929', end: '3/1/1933' },
    // { start: '5/1/1937', end: '6/1/1938' },
    // { start: '2/1/1945', end: '10/1/1945' },
    // { start: '11/1/1948', end: '11/1/1949' },
    // { start: '7/1/1953', end: '5/1/1954' },
    // { start: '8/1/1957', end: '4/1/1958' },
    // { start: '4/1/1960', end: '2/1/1961' },
    // { start: '12/1/1969', end: '11/1/1970' },
    // { start: '11/1/1973', end: '3/1/1975' },
    // { start: '1/1/1980', end: '7/1/1980' },
    // { start: '7/1/1981', end: '11/1/1982' },
    // { start: '7/1/1990', end: '3/1/1991' },
    // { start: '3/1/2001', end: '11/1/2001' },
    // { start: '12/1/2007', end: '6/6/2009' },
    { start: '2/1/2020', end: recessionEnd }];
  recessionData.forEach((d) => { d.start = rParser(d.start); d.end = rParser(d.end); });

  // const maxValue = max(data, d => max(d.values, v => v.value));
  // const minValue = min(data, d => min(d.values, v => v.value));

  const xAxisConfig = {
    orientation: 'bottom',
    domain: extent(raw, d => parser(d.date)),
    range: [0, width],
    nice: false,
  };

  // console.log(minValue, maxValue);

  const yAxisConfig = {
    orientation: 'left',
    domain: [62000, 78000],
    range: [height, 0],
    nice: false,
  };

  const { axis: xAxis, scale: x } = timeAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  //  const colorRange = ['#00bcf0', '#5b7b93', '#B6E2F9', '#004969'];
  const colorRange = ['#00BCF0', '#004969'];
  const color = ordinalScale({ range: colorRange, domain: keys });

  const path = line()
    .defined(d => !isNaN(d.value))
    // .curve(curveMonotoneX)
    .x(d => x(d.date))
    .y(d => y(d.value));

  return {
    color,
    data,
    fmtYearAbbrev: timeFormat('%y'),
    fmtYearFull: timeFormat('%Y'),
    fmtMonth: timeFormat('%B'),
    initialWidth,
    initialHeight,
    margins,
    height,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    recessionData,
    calloutValue,
    calloutLabel,
  };
}
